import React from 'react';
import { Section, CTAButton } from './Shared';
export const EmotionalClose = () => {
  return <Section className="max-w-3xl" data-id="element-35">
      <div className="glass-panel p-8 md:p-12 rounded-3xl text-center bg-white/80 border-brand-pink/30 shadow-lg" data-id="element-36">
        <h2 className="text-2xl md:text-4xl font-serif font-bold mb-8 text-brand-text" data-id="element-37">
          Hay dos versiones de vos en este momento.
        </h2>

        <div className="space-y-6 text-lg text-brand-text/80 mb-10" data-id="element-38">
          <p data-id="element-39">Una que cierra esta página y la semana que viene sigue igual.</p>
          <p className="font-medium text-brand-rose" data-id="element-40">
            Y otra que decide que hoy es diferente.
          </p>
          <p data-id="element-41">$15.990 pesos. Imprimís. Organizás. Profesionalizás.</p>
          <p className="font-serif italic text-xl" data-id="element-42">
            La pregunta no es si podés pagarlo.
            <br data-id="element-43" />
            La pregunta es si podés seguir sin hacerlo.
          </p>
        </div>

        <div className="glass-panel rounded-3xl p-8 md:p-10 flex flex-col border-brand-rose relative shadow-[0_10px_40px_rgba(212,115,140,0.15)] bg-white/80 text-center mb-10" data-id="element-44">
          <div className="mb-6" data-id="element-45">
            <h4 className="text-2xl font-serif font-bold mb-2 text-brand-text" data-id="element-46">
              KIT REFLEXO-PRO COMPLETO
            </h4>
            <p className="text-brand-rose/90 font-medium" data-id="element-47">
              Tomo Principal + Bonus 1 + Bonus 2 · 110 páginas
            </p>
          </div>

          <div className="mb-8" data-id="element-48">
            <div className="text-xl text-brand-text/50 line-through mb-1" data-id="element-49">
              $62.000 ARS
            </div>
            <div className="text-5xl font-bold text-brand-text mb-2" data-id="element-50">
              $15.990
            </div>
          </div>

          <div className="mt-auto" data-id="element-51">
            <CTAButton fullWidth className="text-lg py-5 animate-pulse-slow" href="https://www.lumenakasha.com/cart/46722804678845:1" data-id="element-52">
              🦶 → QUIERO MI KIT REFLEXO-PRO AHORA
            </CTAButton>
          </div>
        </div>

        <div className="text-sm text-brand-text/60 bg-brand-surfaceLight/20 p-6 rounded-2xl border border-brand-pink/20 space-y-3 text-left md:text-center" data-id="element-53">
          <p data-id="element-54">
            <strong className="text-brand-text/80" data-id="element-55">P.D.:</strong> Tenés dudas.
            Escribinos a{' '}
            <a href="mailto:soportelumenakasha@gmail.com" className="text-brand-rose hover:underline" data-id="element-56">
              soportelumenakasha@gmail.com
            </a>{' '}
            o a{' '}
            <a href="https://instagram.com/lumen.akasha" className="text-brand-rose hover:underline" data-id="element-57">
              @lumen.akasha
            </a>
            . Te respondemos hoy.
          </p>
          <p data-id="element-58">
            El precio de $15.990 es de lanzamiento. Sube pronto. El mejor
            momento para empezar es ahora.
          </p>
        </div>
      </div>
    </Section>;
};